import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var IdCardIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M20.975 3.46H3.015c-1.74 0-2.37 1.42-2.37 2.37v12.34c0 1.74 1.42 2.37 2.37 2.37h17.97c1.74 0 2.37-1.42 2.37-2.37V5.83c0-1.74-1.42-2.37-2.37-2.37h-.01zm.37 14.69c-.02.38-.21.38-.37.38H3.025c-.38-.02-.38-.21-.38-.37V5.84c.02-.38.21-.38.37-.38h17.95c.38.02.38.21.38.37v12.32z"
                        }),
                        _jsx("path", {
                            d: "M18.915 9.21h-3.16c-.55 0-1 .45-1 1s.45 1 1 1h3.16c.55 0 1-.45 1-1s-.45-1-1-1zm0 3.14h-3.16c-.55 0-1 .45-1 1s.45 1 1 1h3.16c.55 0 1-.45 1-1s-.45-1-1-1zm-7.05.85s-.09-.05-.13-.07c.59-.66.92-1.5.92-2.39 0-.96-.38-1.87-1.06-2.55-1.36-1.36-3.74-1.37-5.11 0-.68.68-1.06 1.59-1.06 2.55 0 .89.33 1.73.92 2.39-.05.03-.1.05-.14.08-.86.57-1.56 1.35-2.03 2.27-.25.49-.06 1.09.43 1.35a1 1 0 001.35-.43c.32-.61.79-1.14 1.36-1.52.52-.34 1.11-.52 1.73-.52.6 0 1.2.18 1.73.52.57.38 1.04.91 1.36 1.52.18.34.53.54.89.54.15 0 .31-.04.46-.11.49-.25.68-.86.43-1.35-.47-.92-1.17-1.7-2.04-2.28h-.01zm-3.96-3.6c.31-.3.71-.47 1.14-.47.43 0 .84.17 1.14.47.3.3.47.71.47 1.14 0 .43-.17.84-.47 1.14-.61.6-1.68.6-2.28 0-.3-.3-.47-.72-.47-1.14 0-.42.17-.84.47-1.14z"
                        })
                    ]
                })
            })
        ]
    });
};
IdCardIcon.isCarinaIcon = true;
export default IdCardIcon;
